<template>
  <modal show-on-mount :title="modalTitle" modal-id="join-group-modal"
         @visibility-changed="handleVisibilityChanged">
    <template #body>
      <new-member-form :submit-button-label="i18n.t('local_chapters.join.join_local_chapter')" :submitting="submitting"
                       @submit="submit" />
    </template>
  </modal>
</template>

<script>
import ajax from '@/helpers/ajax'
import { mapMutations, mapState } from 'vuex'
import Modal from '@/components/modal'
import NewMemberForm from './new-member-form'

export default {
  components: { Modal, NewMemberForm },

  emits: ['closed', 'group-member-created'],

  data() {
    return {
      submitting: false
    }
  },

  computed: {
    ...mapState({
      defaultNotificationLevel: 'defaultNotificationLevel',
      extraParams: 'joinExtraParams',
      group: 'group',
      groupMembersUrl: 'groupMembersUrl',
      newMember: 'newMember'
    }),

    groupMemberData() {
      // This is the data block we'll submit for creating the group member
      return {
        notification_level: this.newMember.notificationLevel,
        additional_fields: this.newMember.additionalFieldValues,
        eu_data_processing_consent: this.newMember.dataProcessingConsent,
        new_member_question_responses: this.newMember.newMemberQuestionResponses,
        ...this.extraParams
      }
    },

    modalTitle() {
      return this.i18n.t('public.groups.join.join_name', {group_name: this.group.name})
    }
  },

  created() {
    this.initializeNewMember()
  },

  methods: {
    ...mapMutations(['initializeNewMember', 'setNewMemberValidationErrors']),

    handleVisibilityChanged(visibility) {
      if (visibility === 'hidden') {
        this.$emit('closed')
      }
    },

    submit() {
      this.submitting = true

      ajax.post({
        url: this.groupMembersUrl,
        data: {
          local_chapter_member: this.groupMemberData
        },
        camelCaseResponse: false,
        successHandler: () => {
          this.submitting = false
          this.$emit('group-member-created')
        },
        errorHandler: ({ info }) => {
          this.setNewMemberValidationErrors(info.errors)
          this.submitting = false
        }
      })
    }
  }
}
</script>
